// Updated: 2026-08-13
import { QueryClientProvider } from '@tanstack/react-query'
import { Amplify } from 'aws-amplify'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { authConfig } from './config/auth'
import { AuthProvider } from './context/AuthContext'
import { CraftRoomProvider } from './context/CraftRoomContext'
import { UserRelationsProvider } from './context/UserRelationsContext.tsx'
import { createQueryClient } from './queries/queryClient'

// Load Google Fonts
const link = document.createElement('link')
link.href =
  'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=Roboto:wght@400;500;600;700&display=swap'
link.rel = 'stylesheet'
document.head.appendChild(link)

Amplify.configure({
  Auth: authConfig,
})

// Create QueryClient. The shared defaults (staleTime 5 min / gcTime 10 min, refetchOnWindowFocus
// off, and the status-aware retry predicate that NEVER retries 4xx) live in ./queries/queryClient so
// the unit tests can exercise the same policy production runs.
const queryClient = createQueryClient()

// Render App
// Non-null assertion: 'root' element is guaranteed to exist in index.html
const root = ReactDOM.createRoot(document.getElementById('root')!)
root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <UserRelationsProvider>
          <CraftRoomProvider>
            <App />
          </CraftRoomProvider>
        </UserRelationsProvider>
      </AuthProvider>
    </QueryClientProvider>
  </BrowserRouter>,
)
